module.exports = {
          srcSet: __webpack_public_path__ + "c2f87eaa7134d098d0383bb6c3ed02bb-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "c2f87eaa7134d098d0383bb6c3ed02bb-60.png",width: 60,height: 17}],
          src: __webpack_public_path__ + "c2f87eaa7134d098d0383bb6c3ed02bb-60.png",
          toString:function(){return __webpack_public_path__ + "c2f87eaa7134d098d0383bb6c3ed02bb-60.png"},
          
          width: 60,
          height: 17
        }